import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { BeverageService } from '../../services/dal/beverage.service';
import { IBeverage } from '../../models/beverage';
import { IonicModule, ModalController } from '@ionic/angular';
import { Observable, Subscription, tap } from 'rxjs';
import { SubscriptionHandler } from '../../services/subscriptionHandler.service';

import * as fromUser from "app/state/user/reducer";
import { Store } from '@ngrx/store';

import { FormsModule } from '@angular/forms';
import * as fromBeverage from 'app/state/beverage';
import { LetDirective } from '@ngrx/component';


@Component({
  selector: 'app-select-beverage',
  templateUrl: './select-beverage.component.html',
  styleUrls: ['./select-beverage.component.scss'],
  standalone: true,
  imports: [IonicModule, FormsModule, LetDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectBeverageComponent {

  items: IBeverage[] = [];
  allItems$ = this.store.select(fromBeverage.selectBeveragesSortedByDate).pipe(
    tap(items => {
      this.items = JSON.parse(JSON.stringify(items));
    })
  );
  searchQuery!: string;
  subs: Subscription[] = [];
  barId$ = this.store.select(fromUser.selectBarId);

  constructor(
    private store: Store,
    private modalController: ModalController,
  ) { }


  selectItem(item: IBeverage) {
    this.modalController.dismiss({
      item
    });
  }

  closeModal() {
    this.modalController.dismiss({
      dismissed: true
    });
  }
  onSearch(event: any, allItems: IBeverage[]) {
    this.items = JSON.parse(JSON.stringify(allItems));
    const searchTerm = event.srcElement.value;

    if (!searchTerm) {
      return;
    }

    this.items = this.items.filter(item => {

      if (searchTerm) {
        let nameOk = false;
        let styleOk = false;
        if (item.name) {
          nameOk = (item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);
        }
        if (item.beerStyle) {
          styleOk = (item.beerStyle.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);
        }
        return nameOk || styleOk;
      }
      return false;
    });
  }

}
